module.exports = __webpack_public_path__ + "img/icon-brand-asana.cff80220.svg";